import { Tab, Tabs } from "@mui/material";
import { useHistory } from "react-router-dom";
import SwipeableViews from "react-swipeable-views";
import { Row } from "reactstrap";
import { useState } from "react";
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import useWindowHeight from "../../../Hooks/useWindowHeight";
import AddToHomeScreenImages from "./AddToHomeScreenImages";
import HeaderWithReturnFunction from "../../HeaderWithReturnFunction";

enum TabsOS {
    Android = 0,
    Apple,
}

const ManualAddAppToHomeScreen = () => {
    const history = useHistory();
    const { windowHeight } = useWindowHeight();
    const [selectedTab, setSelectedTab] = useState<TabsOS>(TabsOS.Android);

    const getButtonDiv = () => {
        return (
            <div className="fixed-bottom" style={{ color: "#2F5FA1" }}>
                <Tabs
                    value={selectedTab}
                    indicatorColor="primary"
                    textColor="inherit"
                    variant="fullWidth"
                    onChange={(_event, value) => setSelectedTab(value)}
                >
                    <Tab icon={<AndroidIcon />} label="Android" />
                    <Tab icon={<AppleIcon />} label="iOS" />
                </Tabs>
            </div>
        );
    }

    return (
        <>
            <HeaderWithReturnFunction 
                title={"Beginscherm plaatsen"} 
                returnFunction={() => history.goBack()} 
            />

            {getButtonDiv()}

            <div className="m-0" 
                style={{height: `calc(${windowHeight}px - 54px)`, overflowY: "auto", overflowX: "hidden", maxHeight: "-webkit-fill-available"}}
            >
                <SwipeableViews
                    axis={"x"}
                    disabled={true}
                    index={selectedTab}
                    onChangeIndex={(index: number) => setSelectedTab(index)}
                >
                    <Row
                        className="m-0 align-items-center"
                        style={{
                            height: `calc(${windowHeight}px - 120px)`,
                            overflowY: "auto",
                            overflowX: "hidden",
                            maxHeight: "-webkit-fill-available",
                            width: "100%"
                        }}
                    >
                        <AddToHomeScreenImages
                            isAndroidSection={true}
                        />
                    </Row>
                    <Row
                        className="m-0 align-items-center"
                        style={{
                            height: `calc(${windowHeight}px - 120px)`,
                            overflowY: "auto",
                            overflowX: "hidden",
                            maxHeight: "-webkit-fill-available",
                            width: "100%"
                        }}
                    >
                        <AddToHomeScreenImages
                            isAndroidSection={false}
                        />
                    </Row>
                </SwipeableViews>
            </div>
        </>
    );
}

export default ManualAddAppToHomeScreen;